import { TrackerTarget } from '@kueski-dev/web-observability';
import { getVariable } from 'Utils/env';

export const AMPLITUDE_KUESKI = getVariable('AMPLITUDE_KUESKI_ACCOUNT') as TrackerTarget;
export const BRAZE_KUESKI = getVariable('BRAZE_KUESKI_ACCOUNT') as TrackerTarget;
